import { useQuery } from '@tanstack/react-query'
import { fetchEnsTransitOperationV3, fetchTransitOperationV2 } from './http'
import { fromTransitOperationResponse } from '../models/mapper'
import { TransitOperation } from '../models/types'
import { QueryKeys } from '../../../key-registry'

export async function fetchTransitOperation(
  id: number,
  isEns?: boolean,
  opts?: { signal?: AbortSignal },
): Promise<TransitOperation> {
  const response = isEns
    ? await fetchEnsTransitOperationV3(id, opts)
    : await fetchTransitOperationV2(id, opts)

  return fromTransitOperationResponse(response)
}

export function useFetchTransitOperation(
  id: number | null,
  isEns: boolean,
) {
  return useQuery({
    queryKey: QueryKeys.transitOperation.detail({ id, isEns }),
    enabled: !!id,
    queryFn: ({ signal }) => fetchTransitOperation(id as number, isEns, { signal }),
    staleTime: 0,
  })
}
